import { Pipe, PipeTransform } from '@angular/core';
import { ISSUER_MAPPING } from '@zero/leverage-products/domain';
import { LeverageProductType } from '@zero/shared/util-models';
import { Derivative } from '@zero/trading-tools/domain';

@Pipe({
  name: 'trackingQueryParams',
  standalone: true,
})
export class TrackingQueryParamsPipe implements PipeTransform {
  public transform(derivative: Derivative, type: LeverageProductType, underlyingIsin: string, location: string): unknown {
    const instrument = type === LeverageProductType.CALL ? derivative.call : derivative.put;
    const issuer = ISSUER_MAPPING[instrument?.issuerName] ?? instrument?.issuerName;
    const lev = derivative.targetLeverage > 10 ? 'levmax' : `lev${derivative.targetLeverage}x`;
    const direction = type === LeverageProductType.CALL ? 'Long' : 'Short';
    const orderMaskRelevantParameters =
      location === 'button'
        ? {
            direction: 'buy',
            isin: instrument?.isin,
          }
        : {};
    return {
      ...orderMaskRelevantParameters,
      fzsrc: 'zerocockpit',
      fzmedium: 'web',
      fzcampaign: `trading-matrix-KO-${direction}-${issuer}`,
      fzterm: instrument?.isin,
      fzcontent: `${location}-${lev}-${lev}-${underlyingIsin}`,
    };
  }
}
